import { Controller } from "@hotwired/stimulus"

// Polls the check_payment endpoint to detect when payment succeeds.
// Automatically reloads the page when payment status changes.
export default class extends Controller {
  static values = { url: String, interval: { type: Number, default: 5000 } }

  connect() {
    this.poll()
  }

  disconnect() {
    this.stopPolling()
  }

  poll() {
    this.timer = setInterval(() => {
      fetch(this.urlValue, {
        headers: { "Accept": "application/json" }
      })
        .then(response => response.json())
        .then(data => {
          if (data.status === "paid") {
            // All orders paid — reload and stop polling
            this.stopPolling()
            window.location.reload()
          } else if (data.updated && data.updated.length > 0) {
            // Some orders were just marked as paid — reload to refresh badges
            window.location.reload()
          }
        })
        .catch(() => {
          // Silently ignore fetch errors, will retry next interval
        })
    }, this.intervalValue)
  }

  stopPolling() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }
}
